import React from 'react';
import ClientActivityFeed from './components/ClientActivityFeed';
import { clientActivity, clientKpis } from '../../mocks/client';
import DataModeBadge from '../../components/feedback/DataModeBadge';

function ClientActivityPage() {
  return (
    <main className="portal-page">
      <header className="portal-page-head">
        <div>
          <p className="eyebrow">ACTIVITY</p>
          <h1>
            What your agents did{' '}
            <DataModeBadge mode="sample" label="Sample data — backend pending" />
          </h1>
          <span>Plain-English summaries — the technical detail stays with us.</span>
        </div>
      </header>

      <section className="portal-kpis portal-kpis-compact">
        {clientKpis.slice(0, 3).map((kpi) => (
          <div className="portal-kpi" key={kpi.id}>
            <span>{kpi.label}</span>
            <strong>{kpi.value}</strong>
            <em className={`tone-${kpi.tone}`}>{kpi.delta}</em>
          </div>
        ))}
      </section>

      <section className="portal-card">
        <div className="portal-card-head">
          <div>
            <h2>Recent work</h2>
            <span>{clientActivity.length} updates</span>
          </div>
        </div>
        <ClientActivityFeed />
      </section>
    </main>
  );
}

export default ClientActivityPage;
